<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-flex xs12 class="edit-hotel-container">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-tabs v-model="tab.value" grow background-color="teal lighten-5">
        <v-tabs-slider color="primary"/>
        <v-tab v-for="tab in tab.tabs" :key="tab.label">
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab.value">
        <v-tab-item v-for="tab in tab.tabs" :key="tab.value">
          <v-card flat v-if="tab.value === 0">
            <v-card-text>
              <v-layout wrap row justify-center>
                <v-flex xs12 sm12 md5>
                  <v-text-field
                    v-model="hotel.name"
                    :rules="rules"
                    :label="$t('hotel.name')"
                    required/>
                  <p>Kognitiv Property Code: {{ hotel.externalId }}</p>
                  <p>{{ $t('hotel.currency') }}:
                    <span v-if="hotel.currency === 'EUR'">
                        <v-icon small color="black">euro_symbol</v-icon>
                      </span>
                    <span v-else>
                      {{ hotel.currency }}
                      </span>
                  </p>
                  <v-text-field
                    v-model="hotel.url"
                    :rules="rules"
                    :label="$t('hotel.url')"/>
                  <h2 style="margin-bottom: 15px;">{{ $t('hotel.contact.text') }}</h2>
                  <v-text-field
                    v-model="hotel.contact.contactName"
                    :rules="rules"
                    :label="$t('hotel.contact.name')"
                    required/>
                  <v-text-field
                    v-model="hotel.contact.contactEmail"
                    :rules="emailRules"
                    :label="$t('hotel.contact.email')"
                    required/>
                  <h2 style="margin-bottom: 15px;">{{ $t('hotel.address.contact') }}</h2>
                  <v-text-field
                    v-model="hotel.address.landLine"
                    :label="$t('hotel.address.landLine')"/>
                  <v-text-field
                    v-model="hotel.address.mobile"
                    :label="$t('hotel.address.mobile')"/>
                  <v-text-field
                    v-model="hotel.address.fax"
                    :label="$t('hotel.address.fax')"/>
                  <v-text-field
                    v-model="hotel.address.email"
                    :label="$t('hotel.address.email')"/>
                </v-flex>
                <v-flex xs12 sm12 md5 offset-md1>
                  <v-layout wrap row>
                    <v-select
                      :items="hotelTypes"
                      item-text="label"
                      item-value="value"
                      v-model="hotel.hotelType"
                      :label="$t('hotel.selectHotelType')"
                      :rules="rules"
                      :disabled="true"
                      :hint="$t('hotel.kognitiv.onlyOnce')"
                      persistent-hint
                      required/>
                  </v-layout>
                  <v-layout wrap row>
                    <v-checkbox color="primary"
                                v-model="hotel.noChildren"
                                label="Es sind keine Kinderregelungen erlaubt"
                    />
                  </v-layout>
                  <v-layout wrap row>
                    <v-checkbox color="primary"
                                v-model="hotel.roundPrice"
                                label="Preise kaufmännisch runden"
                    />
                  </v-layout>
                  <v-layout wrap row>
                    <h2 style="margin-bottom: 15px;">{{ $t('hotel.address.text') }}</h2>
                  </v-layout>
                  <v-layout wrap row>
                    <v-text-field
                      v-model="hotel.address.addressLine1"
                      :rules="rules"
                      :label="$t('hotel.address.addressLine1')"
                      required/>
                  </v-layout>
                  <v-layout wrap row>
                    <v-text-field
                      v-model="hotel.address.addressLine2"
                      :label="$t('hotel.address.addressLine2')"/>
                  </v-layout>
                  <v-layout wrap row>
                    <v-flex xs12 sm5>
                      <v-text-field
                        v-model="hotel.address.zip"
                        :label="$t('hotel.address.zip')"/>
                    </v-flex>
                    <v-flex xs12 sm5 offset-sm2>
                      <v-text-field
                        v-model="hotel.address.city"
                        :rules="rules"
                        label="Ort"
                        required/>
                    </v-flex>
                    <v-flex xs12 sm5>
                      <v-text-field
                        v-model="hotel.address.region"
                        :label="$t('hotel.address.region')"/>
                    </v-flex>
                    <v-flex xs12 sm5 offset-sm2>
                      <v-text-field
                        v-model="hotel.address.land"
                        :counter="2"
                        :rules="rules"
                        :label="$t('hotel.address.land')"
                        required/>
                    </v-flex>
                    <h2 style="margin-bottom: 15px;">{{ $t('hotel.address.gps') }}</h2>
                    <v-flex xs12 sm5>
                      <v-text-field
                        v-model="hotel.address.gps.longitude"
                        :label="$t('hotel.address.longitude')"/>
                    </v-flex>
                    <v-flex xs12 sm5 offset-sm2>
                      <v-text-field
                        v-model="hotel.address.gps.latitude"
                        :label="$t('hotel.address.latitude')"/>
                    </v-flex>
                    <h2 style="margin-bottom: 15px;">Betriebsurlaub</h2>
                    <v-btn outlined color="primary"
                           @click="holiday.dialog = true"
                           style="margin-left: 0">Betriebsurlaub verwalten</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 1">
            <v-card-text>
              <v-layout wrap row justify-center>
                <v-flex xs12 sm12 md5>
                  <h2>{{ $t('hotel.user.manager') }}</h2>
                  <v-text-field
                    v-model="hotel.manager.firstName"
                    :rules="rules"
                    :label="$t('contact.firstName')"
                    required/>
                  <v-text-field
                    v-model="hotel.manager.lastName"
                    :rules="rules"
                    :label="$t('contact.lastName')"
                    required/>
                  <v-text-field
                    v-model="hotel.manager.password"
                    :label="$t('profile.password')"/>
                  <v-text-field
                    v-model="hotel.manager.username"
                    :rules="emailRules"
                    :label="$t('hotel.contact.email')"
                    required/>
                </v-flex>
                <v-flex xs12 sm12 md5 offset-md1>
                  <h2>{{ $t('hotel.user.staff') }}</h2>
                  <v-data-table
                    :headers="staff.headers"
                    :items="hotel.staff">
                    <template v-slot:item="props">
                      <tr>
                        <td class="text-sm-left">
                          <p/>
                          <h3>{{ props.item.firstName }} {{ props.item.lastName }}</h3>
                          <p>{{ props.item.username }}</p>
                        </td>
                        <td>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon @click="removeStaff(props.item)" v-on="on" color="red">delete</v-icon>
                            </template>
                            <span>{{ $t("delete") }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-layout wrap row align-left>
                    <v-btn color="primary" outlined @click="staff.dialog = true" style="margin-left: 0">
                      <v-icon left>person_add</v-icon>
                      {{ $t('hotel.user.addStaff') }}
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 2">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-data-table
                    :headers="room.headers"
                    :items="hotel.kognitivHotelRooms"
                    :items-per-page="50"
                    hide-default-footer
                    item-key="name">
                    <template v-slot:item="props">
                      <tr>
                        <td>
                          <v-layout wrap row justify-space-between pb-2 pt-2 style="height: 100%;">
                            <v-flex xs12>
                              <v-toolbar flat color="teal lighten-5">
                                <v-toolbar-title>
                                  <v-edit-dialog
                                    :return-value.sync="props.item.name"
                                    lazy>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <div v-on="on">{{ props.item.name }} ({{ props.item.externalId }})</div>
                                      </template>
                                      <span>Bearbeiten</span>
                                    </v-tooltip>
                                    <v-text-field
                                      slot="input"
                                      v-model="props.item.name"
                                      label="Zimmername"
                                      single-line
                                    />
                                  </v-edit-dialog>
                                </v-toolbar-title>
                                <v-spacer/>
                                <v-toolbar-items>
                                  <v-checkbox
                                    color="primary"
                                    v-model="props.item.ignore"
                                    label="Preisberechnung ignorieren"
                                    style="margin-top: 18px;margin-right: 15px;"
                                  />
                                  <v-text-field
                                    style="max-width: 70px;height: 50px;margin-top: 16px;margin-right: 10px;"
                                    color="primary"
                                    label="Position"
                                    type="number"
                                    v-model="props.item.position"
                                    required/>
                                  <v-icon @click="openRoomDialog(props.item)">edit</v-icon>
                                </v-toolbar-items>
                              </v-toolbar>
                              <v-list two-line>
                                <v-subheader>
                                  {{ $t('hotel.kognitiv.rateplan') }}
                                </v-subheader>
                                <v-divider/>
                                <v-list-item v-for="(rate, index) in props.item.kognitivRatePlans"
                                             style="height: 30px;min-height: 30px;"
                                             :key="'kogRatePlan_'+index">
                                  <v-list-item-avatar>
                                    <v-icon small color="primary">label</v-icon>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ rate.ratePlan }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-subheader style="height: 100%;"
                                  v-if="props.item.kognitivRatePlans.length === 0">
                                  <v-flex xs12>
                                    <v-alert style="padding: 10px !important;margin-top: 15px;" :value="true" color="error" outlined>
                                      {{$t('hotel.kognitiv.ratesNotSelectedYet')}}
                                    </v-alert>
                                  </v-flex>
                                </v-subheader>
                              </v-list>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout wrap row justify-space-around align-end style="height: 100%;">
                                <v-btn outlined @click="openRoomSettings(props.item)" color="primary">
                                  {{$t('hotel.settings.select')}}
                                </v-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout wrapF row justify-space-around align-end style="height: 100%;">
                                <v-btn outlined @click="openManageKognitivRates(props.item)"
                                       :disabled="props.item.kognitivRatePlans.length === 0"
                                       color="primary">
                                  Kognitiv Raten verwalten
                                </v-btn>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </td>
                        <td>
                          <v-layout class="text-sm-center" wrap row pb-2 pt-2 align-center style="height: 100%;">
                            <v-flex xs12 v-if="hotel.hotelType !== undefined">
                              <v-alert :value="true" class="text-sm-left" color="error" icon="warning" outlined
                                       v-if="props.item.rates.length === 0">
                                Raten-Matrix wurde noch nicht erstellt!
                              </v-alert>
                              <v-btn outlined color="primary" @click="openRateMatrixDialog(props.item)">
                                {{$t('hotel.manageRateMatrix')}}
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 v-else>
                              <v-alert :value="true" class="text-xs-left" color="error" icon="warning" outlined>
                                Hotel Typ wurde noch nicht bestimmt!
                              </v-alert>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 mt-3>
                  <v-btn outlined color="primary" :loading="room.loadRooms"
                         :disabled="room.loadRooms" style="margin-right: 10px;"
                         @click="refetchRooms()">
                    <v-icon style="margin-right: 10px;">refresh</v-icon>
                    Kognitiv Zimmer neu laden
                  </v-btn>
                  <v-btn outlined color="primary" :loading="room.loadRatePlans"
                         :disabled="room.loadRatePlans"
                         @click="refetchRatePlans()">
                    <v-icon style="margin-right: 10px;">refresh</v-icon>
                    {{ $t('hotel.kognitiv.loadRatePlan') }}
                  </v-btn>
                  <v-btn outlined color="primary"
                         style="margin-left: 10px;"
                         @click="faq.dialog = true">
                    <v-icon style="margin-right: 10px;">info</v-icon>
                    {{ $t('hotel.kognitiv.faq.show') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 3">
            <v-card-text>
              <add-hotel-event :hotel="hotel"/>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 4">
            <v-card-text>
              <add-hotel-protocol :hotel="hotel"/>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 5">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm12 md5 v-if="hotel.rateCategories.length === 0">
                  Es sind noch keine Raten mit eine Kategorie verknüpft.
                </v-flex>
                <v-flex xs12 sm12 md5 v-else>
                  <h3 style="margin-bottom: 10px;">Pauschale</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'FIXED_RATE'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Halbpension</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'HALF_PENSION'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Frühstück</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'BREAKFAST'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Nicht Stornierbar</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'NOT_CANCELLABLE'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Stornierbar</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'CANCELLABLE'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Ohne Verpflegung</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'NO_PENSION'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Vollpension</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'FULL_PENSION'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <h3 style="margin-bottom: 10px;">Unbekannt</h3>
                  <v-layout wrap v-for="(rateCat, index) in hotel.rateCategories"
                            v-if="rateCat.ratePlanCategory === 'UNKNOWN'"
                            :key="'rateCategory_'+index">
                    <v-flex xs8>
                      <h3>{{rateCat.ratePlanName}}</h3>
                      <p style="margin-bottom: 5px;">{{rateCat.ratePlanCode}}</p>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout justify-center style="height: 100%">
                        <v-icon @click="removeRateCategory(index)" color="red">delete</v-icon>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm12 md5 offset-md2>
                  <v-layout wrap row>
                    <v-flex xs12 mb-3>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md6 lg5>
                          <v-text-field
                            v-model="booking.rateCategory.ratePlanName"
                            label="Ratenname"/>
                          <v-text-field
                            v-model="booking.rateCategory.ratePlanCode"
                            label="Ratencode"/>

                          <v-select :items="booking.categories"
                                    item-text="label"
                                    item-value="value"
                                    v-model="booking.rateCategory.ratePlanCategory"
                                    label="Ratenkategorie"/>
                        </v-flex>
                      </v-layout>
                      <v-btn outlined color="primary" style="margin-left: 0;margin-bottom: 10px" @click="addRateCategory()">Rate mit Kategorie verknüpfen</v-btn>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12 mb-3 pb>
                      <h3>Reservierungen für ein Jahrgang löschen</h3>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md6 lg4>
                          <v-text-field type="number"
                                        v-model="booking.year"
                                        label="Jahrgang"
                          />
                        </v-flex>
                      </v-layout>
                      <v-btn color="primary" style="margin-left: 0;margin-bottom: 10px"
                             :loading="booking.delete" :disabled="booking.delete"
                             @click="deleteReservationYear()">Jahrgang löschen</v-btn>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" style="margin-left: 0;margin-bottom: 10px"
                             :loading="booking.reimport" :disabled="booking.reimport"
                             @click="triggerReservationImport()">Alle Reservierungen neu laden</v-btn>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs8 mt-2>
                      <v-file-input truncate-length="60" v-model="upload.file"
                                    accept=".tsv"
                                    label="Datei auswählen"/>
                    </v-flex>
                    <v-flex xs4 mt-2 class="text-sm-right">
                      <v-btn color="primary" style="margin-left: 0; margin-top: 10px;"
                             :loading="upload.loading" :disabled="upload.loading"
                             @click="uploadReservations()">Reservierungen einlesen</v-btn>
                    </v-flex>
                    <v-flex style="color: black;" xs12 v-if="upload.response !== undefined && upload.response === 'PARTIAL'">
                      <strong>Folgende Zeilen konnten nicht gespeichert werden:</strong>
                      <span v-for="(line, index) in upload.lines" :key="'uploadLines_'+index">
                        {{ line }}<span v-if="index < upload.lines.length - 1">, </span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 6">
            <v-card-text>
              <v-flex xs12>
                <occupancy-statistic :hotel="hotel"/>
              </v-flex>
              <v-flex xs12>
                <booking-statistic :hotel="hotel"/>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-card flat v-if="tab.value === 7">
            <add-hotel-notes :hotel="hotel"/>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-form>
    <v-layout wrap mt-2>
      <v-flex xs12>
        <div class="divider-fix"></div>
      </v-flex>
      <v-flex xs12>
        <v-alert :value="hotelForm.valid" class="text-sm-center" color="success" type="success" outlined>
          {{ $t("hotel.updated") }}
        </v-alert>
      </v-flex>
      <v-flex xs12 class="text-sm-right">
        <v-btn color="primary" @click="updateHotel()" :loading="hotelForm.loading" :disabled="hotelForm.disabled">Hotel aktualisieren & speichern</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="holiday.dialog" max-width="700px" persistent>
      <v-card>
        <v-card-title>
          <h2 style="margin-bottom: 30px;">Betriebsurlaub</h2>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md6>
              <v-layout wrap mb-2 v-for="(hol,index) in hotel.holidays" :key="'holiday_'+index">
                <v-flex xs8>
                  <v-layout wrap>
                    <v-flex xs4 sm3 md2>
                      Von:
                    </v-flex>
                    <v-flex xs8 sm9 md10>
                      {{ hol.from | date }}
                    </v-flex>
                    <v-flex xs4 sm3 md2>
                      Bis:
                    </v-flex>
                    <v-flex xs8 sm9 md10>
                      {{ hol.to | date }}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap justify-center>
                    <v-btn icon text style="margin: 0;" small
                           @click="deleteHoliday(index)">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-form v-model="holiday.form" ref="holidayDialogForm" lazy-validation>
                <v-menu :close-on-content-click="false"
                        v-model="holiday.datepicker.from"
                        :nudge-right="40"
                        lazy transition="scale-transition"
                        offset-y full-width min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="holiday.from"
                      label="Von"
                      prepend-icon="event"
                      required
                      :rules="rules"
                      readonly/>
                  </template>
                  <v-date-picker v-model="holiday.from" no-title
                                 first-day-of-week="1" locale="de"
                                 scrollable :allowed-dates="allowedDates"
                                 @input="holiday.datepicker.from = false"/>
                </v-menu>
                <v-menu :close-on-content-click="false"
                        v-model="holiday.datepicker.to"
                        :nudge-right="40"
                        lazy transition="scale-transition"
                        offset-y full-width min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="holiday.to"
                      label="Bis"
                      prepend-icon="event"
                      required
                      :rules="rules"
                      readonly/>
                  </template>
                  <v-date-picker v-model="holiday.to" no-title
                                 first-day-of-week="1" locale="de"
                                 scrollable :allowed-dates="allowedDates"
                                 @input="holiday.datepicker.to = false"/>
                </v-menu>
                <v-btn outlined color="primary" @click="addHoliday()">Betriebsurlaub hinzufügen</v-btn>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="holiday.dialog = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settings.room" max-width="500px">
      <v-card>
        <v-card-title>
          <v-layout wrap row>
            <v-flex xs12>
              <h3 style="margin-bottom: 30px; text-align: left;">Kognitiv Raten auswählen</h3>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout wrap row v-if="room.selected !== undefined">
            <v-flex xs12>
              <v-alert
                :value="true"
                color="info"
                icon="info"
                outlined>
                Wählen Sie die Kognitiv Raten aus, die Sie für die Raten/Preisgestaltungen verwenden möchten.
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-checkbox v-model="room.rates" :key="rate.code" color="primary"
                          v-for="rate in getRatePlanListForRoomWithDeleted(room, rateplans)"
                          :label="rate.code + ''" :value="rate.code + ''"/>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="settings.room = false">{{ $t('close') }}</v-btn>
          <v-btn color="primary" outlined @click.native="selectAllRates()">Alle auswählen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="faq.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <v-layout wrap row>
            <v-flex xs12>
              <h2>{{ $t('hotel.kognitiv.faq.title') }}</h2>
            </v-flex>
            <v-flex xs12 mb-1>
              <div class="divider"></div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout wrap row>
            <v-flex xs12>
              TODO
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="faq.dialog = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="staff.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3 style="margin-bottom: 30px;">{{ $t('hotel.user.createStaff') }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="staff.form" ref="staffForm" lazy-validation>
            <v-flex xs12 class="text-sm-left">
              <v-text-field
                color="primary"
                :label="$t('contact.firstName')"
                :rules="rules"
                v-model="staff.user.firstName"
                required/>
              <v-text-field
                color="primary"
                :label="$t('contact.lastName')"
                :rules="rules"
                v-model="staff.user.lastName"
                required/>
              <h3 style="margin-top: 10px">Anmeldedaten:</h3>
              <v-text-field
                color="primary"
                :label="$t('contact.email')"
                :rules="emailRules"
                v-model="staff.user.username"
                required/>
              <v-text-field
                color="primary"
                :label="$t('profile.password')"
                :rules="rules"
                v-model="staff.user.password"
                required/>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="staff.dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" outlined :loading="staff.loading" :disabled="staff.loading" @click="submitStaff()">{{ $t('hotel.user.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="occupancy.dialog" max-width="700px" persistent>
      <v-card v-if="occupancy.room !== undefined">
        <v-card-title>
          <h3 style="margin-bottom: 30px">Zimmer Einstellungen für {{ occupancy.room.name }} ({{ occupancy.room.externalId }})</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="occupancy.form" ref="roomDialogForm" lazy-validation>
            <v-flex xs12 class="text-xs-left">
              <v-text-field
                color="primary"
                label="Mindestbelegung"
                :rules="rules"
                v-model="occupancy.room.minOccupancy"
                type="number"
                required/>
              <v-text-field
                color="primary"
                label="Standardbelegung"
                :rules="rules"
                v-model="occupancy.room.stdOccupancy"
                type="number"
                required/>
              <v-text-field
                color="primary"
                label="Maximalbelegung"
                :rules="rules"
                v-model="occupancy.room.maxOccupancy"
                type="number"
                required/>
              <v-text-field
                color="primary"
                label="Anzahl der Zimmer"
                :rules="rules"
                v-model="occupancy.room.quantity"
                type="number"
                required/>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="closeRoomDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <manage-rate-matrix/>
    <manage-kognitiv-rate-plans/>
    <v-snackbar
      :color="snackbar.result"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="snackbar.value = false">
        {{$t("close")}}
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
  import RatePlanUtils from '../../../mixins/RatePlanUtils';
  import ManageRateMatrix from './ManageRateMatrix';
  import ManageKognitivRatePlans from './ManageKognitivRatePlans';
  import AddHotelEvent from '../AddHotelEvent';
  import AddHotelProtocol from '../AddHotelProtocol';
  import AddHotelNotes from '../AddHotelNotes';
  import OccupancyStatistic from '../../statistics/OccupancyStatistics';
  import BookingStatistic from '../../statistics/BookingStatistics';

  export default {
    name: 'EditHotel',
    props: {
      hotel: undefined
    },
    components: {
      ManageRateMatrix, ManageKognitivRatePlans, AddHotelEvent, AddHotelProtocol, OccupancyStatistic, BookingStatistic, AddHotelNotes
    },
    mixins: [RatePlanUtils],
    data() {
      return {
        holiday: {
          dialog: false,
          form: undefined,
          to: undefined,
          from: undefined,
          datepicker: {
            to: false,
            from: false,
          }
        },
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        valid: undefined,
        tab: {
          value: 0,
          tabs: [
            { value: 0, label: this.$i18n.t('hotel.tabs.hotelInfo') },
            { value: 1, label: this.$i18n.t('hotel.tabs.user') },
            { value: 2, label: this.$i18n.t('hotel.tabs.room') },
            { value: 3, label: this.$i18n.t('hotel.tabs.events') },
            { value: 4, label: this.$i18n.t('hotel.tabs.protocol') },
            { value: 5, label: this.$i18n.t('hotel.tabs.reservations') },
            { value: 6, label: this.$i18n.t('hotel.tabs.statistics') },
            { value: 7, label: this.$i18n.t('hotel.tabs.notes') }
          ]
        },
        hotelForm: {
          valid: false,
          loading: false,
          disabled: false
        },
        hotelTypes: [
          { value: 'CITYHOTEL', label: this.$i18n.t('hotel.cityHotel') },
          { value: 'HOLIDAYHOTEL', label: this.$i18n.t('hotel.holidayHotel') },
        ],
        staff: {
          dialog: false,
          loading: false,
          form: undefined,
          user: {
            firstName: undefined,
            lastName: undefined,
            password: undefined,
            username: undefined,
          },
          headers: [
            { text: 'Staff', align: 'left', sortable: false },
            { text: this.$i18n.t('manageYieldStaff.actions'), align: 'left', sortable: false },
          ],
        },
        rateplans: [],
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        emailRules: [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid'),
        ],
        room: {
          selected: undefined,
          loadRatePlans: false,
          loadRooms: false,
          rates: [],
          headers: [
            { text: this.$i18n.t('hotel.room'), align: 'left', sortable: false },
            { text: this.$i18n.t('hotel.settings.matrix'), align: 'left', sortable: false },
          ],
        },
        settings: {
          room: false,
        },
        faq: {
          dialog: false,
        },
        occupancy: {
          room: undefined,
          form: undefined,
          dialog: false
        },
        saving: false,
        booking: {
          reimport: false,
          delete: false,
          year: undefined,
          categories: [
            {value:'UNKNOWN', label: 'Unbekannt'},
            {value:'FIXED_RATE', label: 'Pauschale'},
            {value:'CANCELLABLE', label: 'Stornierbar'},
            {value:'NOT_CANCELLABLE', label: 'Nicht Stornierbar'},
            {value:'BREAKFAST', label: 'Frühstück'},
            {value:'HALF_PENSION', label: 'Halbpension'},
            {value:'FULL_PENSION', label: 'Vollpension'},
            {value:'NO_PENSION', label: 'Ohne Verpflegung'}
          ],
          rateCategory: {
            ratePlanCode: undefined,
            ratePlanName: undefined,
            ratePlanCategory: undefined,
          }
        },
        upload: {
          file: undefined,
          loading: undefined,
          response: undefined,
          lines: []
        }
      };
    },
    watch: {
      'room.rates': function (val, oldVal) {
        if (val.length < oldVal.length) { // REMOVE
          const difference = oldVal.filter((item) => {
            return !val.includes(item);
          });
          let index = -1;
          for (let i = 0; i < this.room.selected.kognitivRatePlans.length; i += 1) {
            const rate = this.room.selected.kognitivRatePlans[i];
            if (rate.ratePlan === difference[0]) {
              index = i;
              break;
            }
          }
          if (index !== -1) {
            this.room.selected.kognitivRatePlans.splice(index, 1);
          }
        } else { // ADD
          const difference = val.filter((item) => {
            return !oldVal.includes(item);
          });
          let contains = false;
          if (difference.length > 0) {
            for (let i = 0; i < this.room.selected.kognitivRatePlans.length; i += 1) {
              const rate = this.room.selected.kognitivRatePlans[i];
              if (rate.ratePlan === difference[0] || difference[0] === undefined) {
                contains = true;
                break;
              }
            }
            if (!contains) {
              this.room.selected.kognitivRatePlans.push({
                ratePlan: difference[0],
                name: difference[0],
                kognitivBasePrices: [],
                paymentType: undefined,
                additionalGuestPrice: undefined,
                childrenRules: [],
                paymentMode: undefined, // USED ONLY FOR CUSTOM PAYMENT TYPE
                payment: undefined,     // USED ONLY FOR CUSTOM PAYMENT TYPE
              });
            }
          }
        }
      },
      hotel: {
        handler() {
          this.globalEvents.$emit('hotelEditLeave', true);
        },
        deep: true
      }
    },
    mounted() {
      this.fetchRatePlans();
    },
    methods: {
      uploadReservations() {
        this.upload.loading = true;
        const formData = new FormData();
        formData.append('id', this.hotel.id);
        formData.append('file', this.upload.file);
        this.$http.post('statistic/booking/upload', formData).then((data) => {
          this.upload.response = data.body.uploadResponseState;
          this.upload.lines = data.body.lines;
          if (data.body.uploadResponseState === 'SUCCESS') {
            this.snackbar.result = 'success';
            this.snackbar.text = 'Reservierungen wurden erfolgreich eingespielt.';
          } else if(data.body.uploadResponseState === 'PARTIAL') {
            this.snackbar.result = 'warning';
            this.snackbar.text = 'Nicht alle Reservierungen konnten erfolgreich eingespielt werden.';
          } else {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Reservierungen konnten nicht gespeichert werden.';
          }
          this.snackbar.value = true;
          this.upload.file = undefined;
          this.upload.loading = false;
        });
      },
      removeRateCategory(index) {
        this.hotel.rateCategories.splice(index, 1);
      },
      addRateCategory() {
        if (this.booking.rateCategory.ratePlanCode !== undefined
          && this.booking.rateCategory.ratePlanCategory !== undefined) {
          if (!this.alreadyHasRateCategory()) {
            this.hotel.rateCategories.push(this.booking.rateCategory);
            this.booking.rateCategory = {
              ratePlanCode: undefined,
              ratePlanName: undefined,
              ratePlanCategory: undefined,
            };
          } else {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Rate mit diese Kategorie wurde bereits verknüpft!';
            this.snackbar.value = true;
          }
        } else {
          this.snackbar.result = 'error';
          this.snackbar.text = 'Formular wurde nicht Vollständig ausgefüllt!';
          this.snackbar.value = true;
        }
      },
      alreadyHasRateCategory() {
        for (let i = 0; i < this.hotel.rateCategories.length; i += 1) {
          const rateCategory = this.hotel.rateCategories[i];
          if (rateCategory.ratePlanCode === this.booking.rateCategory.ratePlanCode
            && rateCategory.ratePlanCategory === this.booking.rateCategory.ratePlanCategory) {
            return true;
          }
        }
        return false;
      },
      deleteReservationYear() {
        if (this.booking.year !== undefined) {
          this.booking.delete = true;
          const dto = {
            hotelId: this.hotel.id,
            year: this.booking.year
          };
          this.$http.post('statistic/booking/delete/year', dto).then(() => {
            this.snackbar.result = 'success';
            this.snackbar.text = 'Jahrgang wurde erfolgreich gelöscht.';
            this.snackbar.value = true;
            this.booking.year = undefined;
            this.booking.delete = false;
          });
        }
      },
      triggerReservationImport() {
        this.booking.reimport = true;
        this.$http.get('statistic/booking/reimport/'
                .concat(this.hotel.id)).then(() => {
          this.snackbar.result = 'success';
          this.snackbar.text = 'Alle Buchungen wurden erfolgreich neu geladen.';
          this.snackbar.value = true;
          this.booking.reimport = false;
        });
      },
      deleteHoliday(index) {
        this.hotel.holidays.splice(index, 1);
      },
      addHoliday() {
        if (this.$refs.holidayDialogForm.validate()) {
          this.hotel.holidays.push({
            from: this.holiday.from,
            to: this.holiday.to,
          });
          this.$refs.holidayDialogForm.reset();
        }
      },
      allowedDates(val) {
        const date = this.$moment(val).endOf('day');
        for (let i = 0; i < this.hotel.holidays.length; i += 1) {
          const holiday = this.hotel.holidays[i];
          if (this.$moment(holiday.from).endOf('day').isSameOrBefore(date)
            && this.$moment(holiday.to).endOf('day').isSameOrAfter(date)) {
            return false;
          }
        }
        return true;
      },
      openRoomDialog(room) {
        this.occupancy.room = room;
        this.occupancy.dialog = true;
      },
      closeRoomDialog() {
        if (this.$refs.roomDialogForm.validate()) {
          this.occupancy.dialog = false;
        }
      },
      selectAllRates() {
        const rates = this.getRatePlanListForRoom(this.room.selected.externalId, this.rateplans);
        for (let i = 0; i < rates.length; i += 1) {
          const rate = rates[i];
          if (this.room.selected.kognitivRatePlans.length === 0) {
            this.room.selected.kognitivRatePlans.push({
              ratePlan: rate.code,
              name: rate.code,
              kognitivBasePrices: [],
              paymentType: undefined,
              additionalGuestPrice: undefined,
              childrenRules: [],
              paymentMode: undefined, // USED ONLY FOR CUSTOM PAYMENT TYPE
              payment: undefined,     // USED ONLY FOR CUSTOM PAYMENT TYPE
            });
          } else {
            let contains = false;
            for (let j = 0; j < this.room.selected.kognitivRatePlans.length; j += 1) {
              const kognitivRate = this.room.selected.kognitivRatePlans[j];
              if (kognitivRate.ratePlan === rate.code) {
                contains = true;
              }
            }
            if (!contains) {
              this.room.selected.kognitivRatePlans.push({
                ratePlan: rate.code,
                name: rate.code,
                kognitivBasePrices: [],
                paymentType: undefined,
                additionalGuestPrice: undefined,
                childrenRules: [],
                paymentMode: undefined, // USED ONLY FOR CUSTOM PAYMENT TYPE
                payment: undefined,     // USED ONLY FOR CUSTOM PAYMENT TYPE
              });
            }
          }
        }
        this.settings.room = false;
      },
      updateHotel() {
        this.snackbar.value = false;
        if (!this.$refs.form.validate()) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.requiredFields');
          this.snackbar.value = true;
        } else if (this.hotel.kognitivHotelRooms.length === 0) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.hasNoRoom');
          this.snackbar.value = true;
        } else if (this.hasNoRateMatrix(this.hotel)) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.noRateMatrix');
          this.snackbar.value = true;
        } else if (this.hasNoKognitivRates(this.hotel)) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.noKognitivRates');
          this.snackbar.value = true;
        } else if (this.hasKonitivRateIncomplete(this.hotel)) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.incompleteRatePlans');
          this.snackbar.value = true;
        } else {
          this.hotelForm.loading = true;
          this.hotelForm.disabled = true;
          if (!this.saving) {
            this.saving = true;
            const hotel = this.cleanEditedHotel(this.hotel);
            this.$http.put('hotels/kognitiv', hotel).then((data) => {
              const newHotel = data.body;
              this.globalEvents.$emit('hotelEdited', this.readableEditHotel(newHotel));
              this.hotelForm.valid = true;
              this.hotelForm.loading = false;
              this.hotelForm.disabled = false;
              this.saving = false;
            }, (error) => {
              this.snackbar.result = 'error';
              if (error.bodyText !== undefined && error.bodyText !== null) {
                if (error.bodyText === 'ROOM_PRICE_FAULT') {
                  this.snackbar.text = 'Zimmerpreise unter 10€ !';
                } else {
                  this.snackbar.text = error.bodyText.split('Detail:')[1];
                }
              } else {
                this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
              }
              this.snackbar.value = true;
              this.hotelForm.loading = false;
              this.hotelForm.disabled = false;
              this.saving = false;
            });
          } else {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Speichervorgang bereits gestartet.';
            this.snackbar.value = true;
          }
        }
      },
      submitStaff() {
        if (this.$refs.staffForm.validate()) {
          this.staff.loading = true;
          this.hotel.staff.push(JSON.parse(JSON.stringify(this.staff.user)));
          this.staff.loading = false;
          this.staff.dialog = false;
          this.staff.user = {
            firstName: undefined,
            lastName: undefined,
            password: undefined,
            username: undefined,
          };
          this.$refs.staffForm.reset();
        }
      },
      removeStaff(staff) {
        let index = -1;
        for (let i = 0; i < this.hotel.staff.length; i += 1) {
          if (this.hotel.staff[i].username === staff.username) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          this.hotel.staff.splice(index, 1);
        }
      },
      openRoomSettings(room) {
        this.room.selected = room;
        // RESTORE ROOM RATES
        if (this.room.selected !== undefined) {
          this.room.rates = [];
          for (let i = 0; i < this.room.selected.kognitivRatePlans.length; i += 1) {
            const rate = this.room.selected.kognitivRatePlans[i];
            this.room.rates.push(rate.ratePlan);
          }
        }
        this.settings.room = true;
      },
      openManageKognitivRates(room) {
        this.globalEvents.$emit('openManageKognitivRatePlans', room, this.hotel);
      },
      openRateMatrixDialog(room) {
        this.globalEvents.$emit('openManageRateMatrix', room, this.hotel);
      },
      fetchRatePlans() {
        this.$http.get('kognitiv/rateplans?propertyCode='
          .concat(this.hotel.externalId)).then((body) => {
          this.rateplans = this.getRateplans(body.data);
          this.globalEvents.$emit('create_stopLoadingScreen');
          this.room.loadRatePlans = false;
        });
      },
      refetchRatePlans() {
        this.room.loadRatePlans = true;
        this.fetchRatePlans();
      },
      refetchRooms() {
        this.room.loadRooms = true;
        this.$http.get('kognitiv/hotelInformation?propertyCode='
          .concat(this.hotel.externalId)).then((body) => {
          const rooms = body.data['ota:OTA_HotelDescriptiveInfoRS']['ota:HotelDescriptiveContents']['HotelDescriptiveContent']['FacilityInfo']['GuestRooms']['GuestRoom'];
          this.parseNewHotelRooms(this.hotel.kognitivHotelRooms, rooms);
          const existingRooms = this.getExistingRooms(this.hotel.kognitivHotelRooms, rooms);
          this.hotel.kognitivHotelRooms = [];
          for (let i = 0; i < existingRooms.length; i += 1) {
            this.hotel.kognitivHotelRooms.push(existingRooms[i]);
          }
          this.room.loadRooms = false;
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "../../../assets/scss/layout";

  .edit-hotel-container {
    @include MQ(M) {
      width: 800px;
    }
    @include MQ(L) {
      width: 1000px;
    }
    @include MQ(XL) {
      width: 1200px;
    }

    .v-form {
      width: 100%;
    }

    .v-list {
      background: transparent !important;
      .v-list__tile {
        height: 20px !important;
        .v-list__tile__content {
          height: 20px !important;
        }
      }
    }
  }
</style>
